<template>
  <svg width="32" height="28" viewBox="0 0 32 28" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect width="32" height="28" rx="8" fill="#F7F8FD"/>
    <path d="M18.7812 13.3334L15.2052 9.75736L16.1478 8.8147L21.3332 14L16.1478 19.1854L15.2052 18.2427L18.7812 14.6667H10.6665V13.3334H18.7812Z" fill="black"/>
  </svg>
</template>

<script>
export default {
  name: "SetaParaDireita"
}
</script>

<style scoped>

</style>
